var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"demand-insights-text"},[_c('ul',{staticClass:"mb-0 pl-3"},_vm._l((_vm.summaryItems),function(item,idx){return _c('li',{key:idx,staticClass:"mb-1 small"},[_vm._v(" "+_vm._s(item)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }